// functions/stringConversion.js

/**
 * Split a string into words using various separators, including uppercase letters
 * @param {string} str - The string to split
 * @returns {string[]} - An array of words
 */
export function splitIntoWords(str) {
	return str
			.replace(/([a-z])([A-Z])/g, '$1 $2') // Insert space before uppercase letters that are preceded by a lowercase letter
			.split(/-|_|\.|\s+/) // Split by hyphen, underscore, dot, and spaces (including multiple spaces)
			.map(word => word.toLowerCase()); // Convert everything to lowercase to start fresh
}

/**
 * Convert a string to PascalCase
 * @param {string} str - The string to convert
 * @returns {string} - The converted string
 */
export function toPascalCase(str) {
	return splitIntoWords(str)
			.map(word => word.charAt(0).toUpperCase() + word.slice(1))
			.join('');
}

/**
 * Convert a string to snake_case
 * @param {string} str - The string to convert
 * @returns {string} - The converted string
 */
export function toSnakeCase(str) {
	return splitIntoWords(str)
			.join('_');
}

/**
 * Convert a string to kebab-case
 * @param {string} str - The string to convert
 * @returns {string} - The converted string
 */
export function toKebabCase(str) {
	return splitIntoWords(str)
			.join('-');
}

/**
 * Convert a string to camelCase
 * @param {string} str - The string to convert
 * @returns {string} - The converted string
 */
export function toCamelCase(str) {
	return splitIntoWords(str)
			.map((word, index) =>
					index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
			)
			.join('');
}
